import { useAnimate } from "framer-motion"
import { graphql, Link, navigate, useStaticQuery } from "gatsby"
import React, { useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "./Header.css"

const Header = ({ location }) => {
  const headerData = useStaticQuery(graphql`
    query {
      wp {
        themeGeneralSettings {
          fluxDna {
            bestRateGuaranteedLink {
              target
              title
              url
            }
            whyBookLink {
              target
              title
              url
            }
            openBookingWidgetShow
            enquiry {
              target
              title
              url
            }
            reverieLogo {
              altText
              mediaItemUrl
            }
            darkLogo {
              altText
              mediaItemUrl
              title
            }
            lightLogo {
              altText
              mediaItemUrl
              title
            }
            mainMenu {
              menuLink {
                target
                title
                url
              }
            }
            sidebarMenu1 {
              innerMenu
              viewButton {
                target
                title
                url
              }
              innerMenuLinkOne {
                subMenuImageOne {
                  altText
                  mediaItemUrl
                  title
                }
                subMenuImageTwo {
                  altText
                  mediaItemUrl
                  title
                }
                subMenuLink {
                  target
                  title
                  url
                }
              }
              innerMenuLinkTwo {
                subMenuImageOne {
                  altText
                  mediaItemUrl
                  title
                }
                subMenuImageTwo {
                  altText
                  mediaItemUrl
                  title
                }
                subMenuLink {
                  target
                  title
                  url
                }
              }
              mainMenu {
                target
                title
                url
              }
              preLinkOne {
                target
                title
                url
              }
              preLinkTwo {
                target
                title
                url
              }
              subInnerMenu
            }
            sidebarMenu2 {
              menu {
                target
                title
                url
              }
            }
            searchLink {
              link {
                target
                title
                url
              }
            }
          }
        }
      }
    }
  `)
  const headerDataList = headerData.wp.themeGeneralSettings.fluxDna

  function useScrollDirection() {
    const [scrollDirection, setScrollDirection] = React.useState(null)

    React.useEffect(() => {
      if (typeof window !== "undefined") {
        let lastScrollY = window.pageYOffset

        const updateScrollDirection = () => {
          const scrollY = window.pageYOffset
          const direction = scrollY > lastScrollY ? "down" : "up"
          if (
            direction !== scrollDirection &&
            (scrollY - lastScrollY > 1 || scrollY - lastScrollY < -1)
          ) {
            setScrollDirection(direction)
          }
          lastScrollY = scrollY > 0 ? scrollY : 0
        }
        window.addEventListener("scroll", updateScrollDirection) // add event listener

        return () => {
          window.removeEventListener("scroll", updateScrollDirection) // clean up
        }
      }
    }, [scrollDirection])

    return scrollDirection
  }

  const [menuOpen, setMenuOpen] = useState(false)
  const [scope, animate] = useAnimate()
  const [isVisible, setIsVisible] = useState(false)
  const logolight = headerDataList.lightLogo?.mediaItemUrl
  const logo = headerDataList.darkLogo?.mediaItemUrl

  const [logoSrc, setLogoSrc] = useState(logo)
  const [isLargeScreen, setIsLargeScreen] = useState(
    typeof window !== "undefined" ? window.innerWidth > 768 : false
  )
  const [mobileSubNavOpen, setMobileSubNavOpen] = useState(false)
  const [activeSubmenu, setActiveSubmenu] = useState(null)
  const scrollDirection = useScrollDirection()

  const [hoveredItemId, setHoveredItemId] = useState("submenu1-0-0")
  const handleMouseEnter = index => {
    setHoveredItemId(index)
  }

  const handleMobileMenuActive = menuId => {
    if (activeSubmenu === menuId) {
      setActiveSubmenu(null) // If already active, close it
    } else {
      setActiveSubmenu(menuId) // Activate the selected menu
    }
  }
  useEffect(() => {
    const menuAnimations = menuOpen
      ? [
        [".main-nav", { transform: "translateX(0%)" }, { duration: 0.6 }],
        [
          ".navMenu",
          { transform: "translateX(0px)", opacity: 1 },
          { duration: 0.5, at: "4" },
        ],
      ]
      : [
        [
          ".navMenu",
          { transform: "translateX(-50px)", opacity: 0 },
          { duration: 0.5, at: "1" },
        ],
        [".main-nav", { transform: "translateX(-100%)" }, { duration: 0.6 }],
      ]
    animate([...menuAnimations])
    // Update logo source based on menuOpen state
    setLogoSrc(menuOpen ? logo : logolight)
  }, [scope, menuOpen, animate])

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("menu-open")
      setIsVisible(true)
      document.querySelector("header").classList.remove("header1")
    } else {
      document.body.classList.remove("menu-open")
      setIsVisible(false)
    }
  }, [menuOpen, scrollDirection])

  const MenuToggle = ({ toggle }) => (
    <div className="navbar-icon cursor-pointer" onClick={toggle}>
      <img
        src="../../../images/menu-icon.svg"
        className="menu-icon"
        width={19}
        height={16}
        alt=""
      />
      <Link to="#" className="grid gap-y-1">
        <img
          src="../../../images/close.svg"
          width={15}
          height={15}
          alt="close-icon"
          className="close-icon"
          loading="eager"
        />
      </Link>
    </div>
  )
  const handleMobileMenu = e => {
    const parentHoverable = e.target.closest(".sideNav-hoverable")
    if (parentHoverable) {
      parentHoverable.classList.toggle("mobile-submenu")
    }
    setMobileSubNavOpen(!mobileSubNavOpen)
  }

  const handleMobileSubMenu = () => {
    setMobileSubNavOpen(!mobileSubNavOpen)
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsLargeScreen(window.innerWidth > 992)
      }
      handleResize()
      window.addEventListener("resize", handleResize)
      return () => {
        window.removeEventListener("resize", handleResize)
      }
    }
  }, [])

  const handleBackToHome = () => {
    setMenuOpen(!menuOpen)
  }

  const [isHeaderOnTop, setIsHeaderOnTop] = useState(true)

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleScroll = () => {
        setIsHeaderOnTop(window.pageYOffset === 0)
      }

      window.addEventListener("scroll", handleScroll)
      return () => {
        window.removeEventListener("scroll", handleScroll)
      }
    }
  }, [])

  const [searchIsOpen, setSearchIsOpen] = useState(null)
  const handleSearchOpen = e => {
    e.preventDefault()
    setSearchIsOpen(true)
  }
  const handleSearchClose = () => {
    setSearchIsOpen(false)
  }

  useEffect(() => {
    setSearchtext(params.q)
  }, [])

  const [searchtext, setSearchtext] = useState("")
  const [searchMenu, setSearchMenu] = useState(false)

  let params = {}
  if (typeof window !== "undefined") {
    params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
  }

  useEffect(() => {
    setSearchtext(params.q)
  }, [])

  const [isFormOpen, setIsFormOpen] = useState(false)
  const openReservationForm = e => {
    e.preventDefault()
    setIsFormOpen(!isFormOpen)
  }
  const isHomepage =
    typeof window !== "undefined" && window.location.pathname === "/"

  const [form, setForm] = useState({
    hotel: "",
    arrive: "", // Default to today's date
    depart: "",
    rooms: 1,
    adult: 2,
    child: 0,
    promo: "",
  })

  const [formError, setFormError] = useState("")

  useEffect(() => {
    if (form.arrive) {
      const newDepartDate = new Date(form.arrive)
      newDepartDate.setDate(newDepartDate.getDate() + 1)
      setForm(prev => ({
        ...prev,
        depart: newDepartDate,
      }))
    }
  }, [form.arrive])

  const handleChange = (field, value) => {
    setForm(prev => ({
      ...prev,
      [field]: value,
    }))
    if (formError === field) setFormError("")
  }

  const incrementCounter = field => {
    setForm(prev => ({
      ...prev,
      [field]: prev[field] + 1,
    }))
  }

  const decrementCounter = field => {
    if (form[field] > 1) {
      setForm(prev => ({
        ...prev,
        [field]: prev[field] - 1,
      }))
    }
  }

  const childdecrementCounter = field => {
    if (form[field] > 0) {
      // Allow decrementing down to 0
      setForm(prev => ({
        ...prev,
        [field]: prev[field] - 1,
      }))
    }
  }

  const validateForm = () => {
    if (!form.hotel) return "hotel"
    if (!form.arrive) return "arrive"
    if (!form.depart) return "depart"
    if (form.rooms <= 0) return "rooms"
    if (form.adult <= 0) return "adult"
    return ""
  }

  const handleSubmit = e => {
    e.preventDefault()
    const error = validateForm()
    if (error) {
      setFormError(error)
      return
    }

    const hotelURLs = {
      capeweligama:
        "https://be.synxis.com/?&chain=8565&hotel=65051&theme=capeweligamatheme&config=capeweligamaconfig&clearcache=all&locale=en-US&productcurrency=USD&level=hotel",
      wildcoastlodge:
        "https://be.synxis.com/?&chain=8565&hotel=1604&theme=wildcoastlodge&config=wildcoastlodgeconfig&clearcache=all&locale=en-US&productcurrency=USD&level=hotel",
      ceylonteatrails:
        "https://be.synxis.com/?&chain=8565&hotel=51557&theme=ceylonteatrails&config=ceylonteatrailsconfig&clearcache=all&locale=en-US&productcurrency=USD&level=hotel",
      ahubay: "https://be.synxis.com/?chain=30906&hotel=45164",
      kayaamhouse: "https://be.synxis.com/?chain=30906&hotel=45165",
    }

    const params = new URLSearchParams({
      arrive: form.arrive.toISOString().split("T")[0], // Format as YYYY-MM-DD
      depart: form.depart.toISOString().split("T")[0], // Format as YYYY-MM-DD
      rooms: form.rooms,
      adult: form.adult,
      child: form.child,
      promo: form.promo,
    })
    const hotelURL = hotelURLs[form.hotel]
    if (hotelURL) {
      window.location.href = `${hotelURL}&${params.toString()}`
      //window.open(`${hotelURL}&${params.toString()}`, '_blank');
    } else {
      setFormError("hotel")
    }
  }

  const [isInputVisible, setIsInputVisible] = useState(false) // State for toggling input visibility
  const toggleInputVisibility = () => {
    setIsInputVisible(prevState => !prevState) // Toggle input visibility
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      let navLinks = document.querySelectorAll(".mainNav__col .navMenu li a")
      navLinks.forEach(item => {
        item.addEventListener("click", function () {
          if (menuOpen) {
            setMenuOpen(false)
          }
        })
      })
    }
  }, [menuOpen])

  const [reverieLogo, setReverieLogo] = useState(false)
  useEffect(() => {
    const page = document.querySelector(".fullPageanimation")
    if (page) {
      if (page.classList.contains("reverie-collection")) {
        setReverieLogo(true)
      }
    }
  }, [])

  return (
    <React.Fragment>
      <section ref={scope}>
        <header
          className={`header py-30 fixed top-0 z-[50] w-full transition-common  ${scrollDirection === "down" && !menuOpen ? "!top-[-150px]" : ""
            } ${scrollDirection === "up" &&
              window.pageYOffset !== "0" &&
              !isHeaderOnTop
              ? "header-sticky"
              : ""
            } ${isHeaderOnTop ? "header-on-top" : ""} ${isHomepage ? "homepage-header" : "inner-header"
            }`}
        >
          <div className="container-fluid relative">
            <div className="grid grid-cols-3 items-center">
              <div className="header-left flex flex-wrap items-center gap-x-[15px] lgscreen:gap-x-[8px]">
                <MenuToggle
                  toggle={() => {
                    setMenuOpen(!menuOpen)
                  }}
                  onClick={() => {
                    !menuOpen ? setMenuOpen(true) : setMenuOpen(false)
                  }}
                ></MenuToggle>
                {headerDataList?.mainMenu && (
                  <ul className="header-menu">
                    {headerDataList.mainMenu.map((itemMenu, i) => (
                      <li key={i}>
                        {isLargeScreen ? (
                          <Link
                            to={itemMenu.menuLink.url}
                            className="text-white uppercase font-heading text-16 tracking-05em"
                          >
                            {itemMenu.menuLink.title}
                          </Link>
                        ) : (
                          <Link
                            to="/"
                            className="text-white uppercase font-heading text-16 tracking-05em"
                            onClick={() => {
                              !menuOpen ? setMenuOpen(true) : setMenuOpen(false)
                            }}
                          >
                            Menu
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="logo text-center">
                <div className={`def-logo`}>
                  <Link to="/" className="main-site-logo">
                    <img
                      src={logoSrc}
                      className="mx-auto"
                      width={159}
                      height={38}
                      loading="eager"
                      alt="Logo"
                    />
                  </Link>
                  <Link to="/" className="journal-single-logo">
                    <img
                      src={"/images/journal-single-logo.svg"}
                      className="mx-auto "
                      width={159}
                      height={38}
                      loading="eager"
                      alt="Logo"
                    />
                  </Link>
                  <Link to="/" className="our-journal-logo">
                    <img
                      src={"/images/our-journal-logo.svg"}
                      className="mx-auto "
                      width={159}
                      height={38}
                      loading="eager"
                      alt="Logo"
                    />
                  </Link>
                </div>
                {headerDataList?.darkLogo && (
                  <div className={`stickyHeader-logo`}>
                    <Link to="/" className="main-site-logo">
                      <img
                        src={
                          reverieLogo
                            ? headerDataList?.reverieLogo.mediaItemUrl
                            : headerDataList?.darkLogo.mediaItemUrl
                        }
                        className={`${reverieLogo ? "h-[47px] w-[134px]" : ""
                          } mx-auto`}
                        width={159}
                        height={38}
                        loading="eager"
                        alt={headerDataList?.darkLogo.title}
                      />
                    </Link>
                    <Link to="/" className="journal-single-logo">
                      <img
                        src={"/images/journal-single-logo.svg"}
                        className="mx-auto"
                        width={159}
                        height={38}
                        loading="eager"
                        alt="Logo"
                      />
                    </Link>
                    <Link to="/" className="our-journal-logo">
                      <img
                        src={"/images/our-journal-logo.svg"}
                        className="mx-auto "
                        width={159}
                        height={38}
                        loading="eager"
                        alt="Logo"
                      />
                    </Link>
                  </div>
                )}
              </div>
              <div className="header-right flex flex-wrap items-center justify-end gap-x-[25px]">
                <div className="search-bar mdscreen2:!hidden mr-[230px]">
                  <Link
                    to="/"
                    onClick={e => {
                      handleSearchOpen(e)
                    }}
                  >
                    <img
                      src="../../../images/search.svg"
                      width={15}
                      height={15}
                      loading="eager"
                      alt="Search"
                      className="search-icon"
                    />
                  </Link>
                </div>

                {headerDataList.openBookingWidgetShow && (
                  <button
                    onClick={e => openReservationForm(e)}
                    className={`btn btn-white-border fixed top-30 ${scrollDirection === "down" && !menuOpen
                      ? "btn-everglade"
                      : ""
                      }`}
                  >
                    {!isLargeScreen ? "reserve" : "Make A reservation"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </header>

        <div
          className={`availAbility-modal top-100 transition-all ease-out duration-300 z-[99999] p-25 h-96  w-[297px] fixed right-40 mdscreen:right-30 smscreen:right-20 bg-[#0D0D0D] pointer-events-none ${isFormOpen
            ? "opacity-100 pointer-events-auto translate-x-0"
            : "translate-x-plus_50 opacity-0"
            }`}
        >
          <div className="traveller-enquiry-form w-full">
            <div className="flex flex-col w-full">
              <form className="availibility-form" onSubmit={handleSubmit}>
                <div className="form-wrapper h-full w-full flex flex-col gap-[12px] justify-between">
                  {/* Select Resort */}

                  <div className="form-group">
                    <div className="select_input_container relative">
                      <select
                        id="resort"
                        name="hotel"
                        className="w-full mt-5"
                        value={form.hotel}
                        onChange={e => handleChange("hotel", e.target.value)}
                      >
                        <option value="">Select Resort</option>
                        <option value="capeweligama">Cape Weligama</option>
                        <option value="wildcoastlodge">
                          Wild Coast Tented Lodge
                        </option>
                        <option value="ceylonteatrails">
                          Ceylon Tea Trails
                        </option>
                        <option value="kayaamhouse">Kayaam House</option>
                        <option value="ahubay">Ahu Bay</option>
                      </select>
                    </div>
                    {formError === "hotel" && (
                      <p className="text-red-100 font-heading italic text-12">
                        Please select a resort.
                      </p>
                    )}
                  </div>

                  {/* Arrival Date */}

                  <div className="form-group">
                    <DatePicker
                      name="arrive"
                      selected={form.arrive}
                      onChange={date => handleChange("arrive", date)}
                      className="w-full placeholder:!text-grey-300"
                      placeholderText="Arrival Date"
                      minDate={new Date()}
                    />
                    {formError === "arrive" && (
                      <p className="text-red-100 font-heading italic text-12">
                        Please select an arrival date.
                      </p>
                    )}
                  </div>

                  {/* Departure Date */}
                  <div className="form-group">
                    <DatePicker
                      name="depart"
                      selected={form.depart}
                      onChange={date => handleChange("depart", date)}
                      className="w-full placeholder:!text-grey-300"
                      placeholderText="Departure Date"
                      minDate={
                        form.arrive
                          ? new Date(form.arrive).setDate(
                            form.arrive.getDate() + 1
                          )
                          : new Date()
                      }
                      disabled={!form.arrive}
                    />
                    {formError === "depart" && (
                      <p className="text-red-100 font-heading italic text-12">
                        Please select a departure date.
                      </p>
                    )}
                  </div>

                  <div className="rooms">
                    <div className="input_number relative">
                      <input
                        type="text"
                        placeholder="Number Of Rooms"
                        className="w-full placeholder:text-grey-300"
                        readOnly
                      />
                      <div className="absolute top-0 right-0 flex gap-[6px] items-center max-w-[80px] h-full pr-15">
                        <button
                          type="button"
                          className="minus_btn !static !w-4/12 !p-0"
                          onClick={() => decrementCounter("rooms")}
                        >
                          -
                        </button>
                        <input
                          type="number"
                          value={form.rooms}
                          className="!border-0 !w-4/12 counter-input"
                          // placeholder="Number Of Rooms"
                          readOnly
                        />
                        <button
                          type="button"
                          className="plus_btn !static !w-4/12 !p-0"
                          onClick={() => incrementCounter("rooms")}
                        >
                          +
                        </button>
                      </div>
                      {formError === "rooms" && (
                        <p className="text-red-100 font-heading italic text-12">
                          Please select a number of rooms.
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Adults */}
                  <div className="adults">
                    <div className="input_number relative">
                      <input
                        type="text"
                        placeholder="Adults (16yrs +)"
                        className="w-full placeholder:text-grey-300"
                        readOnly
                      />
                      <div className="absolute top-0 right-0 flex gap-[6px] items-center max-w-[80px] h-full pr-15">
                        <button
                          type="button"
                          className="minus_btn !static !w-4/12 !p-0"
                          onClick={() => decrementCounter("adult")}
                        >
                          -
                        </button>
                        <input
                          type="number"
                          value={form.adult}
                          readOnly
                          className="!border-0 !w-4/12 counter-input"
                        />
                        <button
                          type="button"
                          className="plus_btn !static !w-4/12 !p-0"
                          onClick={() => incrementCounter("adult")}
                        >
                          +
                        </button>
                      </div>
                      {formError === "adult" && (
                        <p className="text-red-100 font-heading italic text-12">
                          Please select a number of adults.
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Children */}
                  <div className="children">
                    <div className="input_number relative">
                      <input
                        type="text"
                        placeholder={form.hotel === "ahubay" ? "Children (12yrs +) only" : "Number of Children"}
                        className="w-full placeholder:text-grey-300"
                        readOnly
                      />
                      <div className="absolute top-0 right-0 flex gap-[6px] items-center max-w-[80px] h-full pr-15">
                        <button
                          type="button"
                          className="minus_btn !static !w-4/12 !p-0"
                          onClick={() => childdecrementCounter("child")}
                        >
                          -
                        </button>
                        <input
                          type="number"
                          value={form.child}
                          readOnly
                          className="!border-0 !w-4/12 counter-input"
                        />
                        <button
                          type="button"
                          className="plus_btn !static !w-4/12 !p-0"
                          onClick={() => incrementCounter("child")}
                        >
                          +
                        </button>
                      </div>
                      {formError === "child" && (
                        <p className="text-red-100 font-heading italic text-12">
                          Please select a number of children.
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Add Coupen */}

                  <div className="form-group">
                    <label
                      htmlFor="promo"
                      className="block text-11 uppercase font-400 text-grey-300 cursor-pointer flex items-center"
                      onClick={toggleInputVisibility}
                    >
                      Add Promo Code
                      <img
                        src="/images/chevron_down_image.svg"
                        alt="Toggle Promo Code"
                        className={`ml-[12px] transition-transform duration-300 ${isInputVisible ? "rotate-180" : ""
                          }`}
                      />
                    </label>
                    <div
                      className={`overflow-hidden transition-all duration-300 ${isInputVisible
                        ? "max-h-[51.5px] opacity-100 mt-10"
                        : "max-h-0 opacity-0"
                        }`}
                    >
                      <input
                        type="text"
                        name="promo"
                        value={form.promo}
                        onChange={e => handleChange("promo", e.target.value)}
                        className="w-full placeholder:!text-grey-300"
                        placeholder="Promo Code"
                      />
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="form-group w-full">
                    <button type="submit" className="btn btn-white-bg w-full">
                      Check availAbility
                    </button>
                  </div>
                  {(headerDataList?.bestRateGuaranteedLink ||
                    headerDataList?.whyBookLink) && (
                      <div className="flex justify-between flex-wrap">
                        {headerDataList?.bestRateGuaranteedLink && (
                          <div>
                            <Link
                              to={headerDataList.bestRateGuaranteedLink.url}
                              target={
                                headerDataList.bestRateGuaranteedLink.target
                              }
                              className="text-[12px] text-white ctm-form-underline"
                            >
                              {headerDataList.bestRateGuaranteedLink.title}
                            </Link>
                          </div>
                        )}
                        {headerDataList?.whyBookLink && (
                          <div>
                            <Link
                              to={headerDataList.whyBookLink.url}
                              target={headerDataList.whyBookLink.target}
                              className="text-[12px] text-white ctm-form-underline"
                            >
                              {headerDataList.whyBookLink.title}
                            </Link>
                          </div>
                        )}
                      </div>
                    )}
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="main-nav">
          <div className="menu-overlay h-full fixed w-full mdscreen:w-full top-0 right-0 bg-white mdscreen:max-w-[310px] mdscreen:left-0"></div>
          <div className="relative md:hidden">
            <div className="flex items-center justify-between w-full max-w-[310px] container-fluid pt-30">
              <button
                type="button"
                onClick={() => {
                  setMenuOpen(!menuOpen)
                }}
              >
                <img
                  src="../../../images/close.svg"
                  width={15}
                  height={15}
                  alt="close-icon"
                  className="subnav-close-icon"
                  loading="eager"
                />
              </button>
              <Link
                to={"/"}
                className="text-12 text-everglade text-opacity-60 capitalize hover:text-opacity-100 transition-common"
                onClick={() => {
                  handleBackToHome()
                }}
              >
                Back To Home
              </Link>
            </div>
          </div>
          <div className="px-60 !pl-100 xlscreen:!pl-60 lgscreen:px-45 mdscreen:!pl-45 pt-[135px] mdscreen2:pt-100 smscreen2:!pt-30 smscreen2:pb-50 h-full smscreen2:overflow-y-auto relative mdscreen:max-w-[310px] mdscreen:!pt-30 smscreen2:!px-40">
            <div className="flex flex-wrap h-full w-full">
              <div className="mainNav__col relative w-5/12 xlscreen:w-6/12 mdscreen2:w-full h-full overflow-y-auto pb-50">
                {headerDataList?.sidebarMenu1 && (
                  <div className="menuOption_wrapper relative pr-20">
                    <ul className="navMenu top-menu hover-underline-solid text-white grid gap-y-20 mdscreen2:gap-y-15 smscreen2:gap-y-10 top-navbar z-99 w-5/12 mdscreen:w-full">
                      {headerDataList.sidebarMenu1.map((itemMenu, k) => (
                        <li
                          key={k}
                          className={`${itemMenu?.innerMenu === true
                            ? "sideNav-hoverable"
                            : ""
                            } `}
                        >
                          <div className="flex flex-wrap items-center justify-between gap-x-15 mdscreen:justify-start">
                            <Link
                              to={itemMenu.mainMenu.url}
                              target={itemMenu.mainMenu.target}
                            >
                              {itemMenu.mainMenu.title}
                            </Link>
                            {itemMenu?.innerMenu === true && (
                              <span className="cursor-pointer menuarrow transition-all duration-300">
                                <img
                                  src="../../../images/arrow-small.svg"
                                  alt="small-arrow"
                                  height={6}
                                  width={8}
                                  className="sideNav-arrow"
                                  onClick={e => {
                                    handleMobileMenu(e, headerDataList)
                                    handleMobileMenuActive(k)
                                  }}
                                />
                              </span>
                            )}
                          </div>
                          {itemMenu?.innerMenu === true && (
                            <div className="mega-menu">
                              <div className="item_wrapper pt-45 mdscreen2:pt-35 first:pt-0">
                                {itemMenu?.preLinkOne && (
                                  <div className="pre-heading title-charcoal">
                                    <Link to="/our-resorts/">
                                      <span>{itemMenu.preLinkOne.title}</span>
                                    </Link>
                                  </div>
                                )}
                                {itemMenu?.innerMenuLinkOne && (
                                  <ul className="space-y-10">
                                    {itemMenu?.innerMenuLinkOne.length > 0 &&
                                      itemMenu.innerMenuLinkOne.map(
                                        (itemS, index) => {
                                          const keyi = `submenu1-${k}-${index}`
                                          return (
                                            <li key={keyi}>
                                              <Link
                                                to={itemS.subMenuLink.url}
                                                target={
                                                  itemS.subMenuLink.target
                                                }
                                                onMouseEnter={() =>
                                                  handleMouseEnter(keyi)
                                                }
                                              >
                                                {itemS.subMenuLink.title}
                                              </Link>
                                            </li>
                                          )
                                        }
                                      )}
                                  </ul>
                                )}
                              </div>
                              <div className="item_wrapper pt-45 mdscreen2:pt-35 first:pt-0">
                                {itemMenu?.preLinkOne && (
                                  <div className="pre-heading title-charcoal">
                                    <Link to="/our-resorts/">
                                      <span>{itemMenu.preLinkTwo.title}</span>
                                    </Link>
                                  </div>
                                )}
                                {itemMenu?.innerMenuLinkTwo && (
                                  <ul className="space-y-10">
                                    {itemMenu?.innerMenuLinkTwo.length > 0 &&
                                      itemMenu.innerMenuLinkTwo.map(
                                        (itemS, index) => {
                                          const keyi = `submenu2-${k}-${index}`
                                          return (
                                            <li key={keyi}>
                                              <Link
                                                to={itemS.subMenuLink.url}
                                                target={
                                                  itemS.subMenuLink.target
                                                }
                                                onMouseEnter={() =>
                                                  handleMouseEnter(keyi)
                                                }
                                              >
                                                {itemS.subMenuLink.title}
                                              </Link>
                                            </li>
                                          )
                                        }
                                      )}
                                  </ul>
                                )}
                              </div>
                              {itemMenu?.viewButton && (
                                <div className="btn-custom pt-50 mdscreen2:pt-35">
                                  <Link
                                    to={itemMenu.viewButton.url}
                                    className="btn btn-border-everglade"
                                    target={itemMenu.viewButton.target}
                                  >
                                    {itemMenu?.viewButton.title}
                                  </Link>
                                </div>
                              )}
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                    <div className="right-hover-items w-7/12 mdscreen:w-full"></div>
                  </div>
                )}
                {headerDataList?.sidebarMenu2 && (
                  <div className="sub-nav pt-40 navMenu">
                    <ul>
                      {headerDataList.sidebarMenu2.map((itemMenu, j) => (
                        <li key={j}>
                          <Link to={itemMenu.menu.url}>
                            {itemMenu.menu.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <div className="sidenav-right w-7/12 xlscreen:w-6/12 mdscreen2:hidden navMenu">
                <div className="relative h-full -mx-10">
                  <div className="image_wrapper w-6/12 h-[calc(100%-135px)] absolute left-0 top-0 px-10">
                    {headerDataList?.sidebarMenu1.length > 0 &&
                      headerDataList.sidebarMenu1.map((itemimg, ig) => (
                        <React.Fragment key={ig}>
                          {Array.isArray(itemimg.innerMenuLinkOne) &&
                            itemimg.innerMenuLinkOne.length > 0 &&
                            itemimg.innerMenuLinkOne.map((itemi, index) => {
                              const keyi = `submenu1-${ig}-${index}`
                              return (
                                <div
                                  key={keyi}
                                  onMouseEnter={() => handleMouseEnter(keyi)}
                                  className={
                                    keyi === hoveredItemId
                                      ? "show-image"
                                      : "hide-image"
                                  }
                                >
                                  {itemi.subMenuImageOne && (
                                    <img
                                      src={itemi.subMenuImageOne.mediaItemUrl}
                                      alt={itemi.subMenuImageOne.title}
                                      height={594}
                                      width={362}
                                      loading="lazy"
                                      className="h-full w-full object-cover object-center"
                                    />
                                  )}
                                </div>
                              )
                            })}
                        </React.Fragment>
                      ))}
                  </div>

                  <div className="image_wrapper w-6/12 h-[calc(100%-135px)] absolute right-0 top-0 px-10">
                    {headerDataList?.sidebarMenu1.length > 0 &&
                      headerDataList.sidebarMenu1.map((itemimg, ig) => (
                        <React.Fragment key={ig}>
                          {Array.isArray(itemimg.innerMenuLinkOne) &&
                            itemimg.innerMenuLinkOne.length > 0 &&
                            itemimg.innerMenuLinkOne.map((itemi, index) => {
                              const keyi = `submenu1-${ig}-${index}`
                              return (
                                <div
                                  key={keyi}
                                  onMouseEnter={() => handleMouseEnter(keyi)}
                                  className={
                                    keyi === hoveredItemId
                                      ? "show-image"
                                      : "hide-image"
                                  }
                                >
                                  {itemi.subMenuImageTwo && (
                                    <img
                                      src={itemi.subMenuImageTwo.mediaItemUrl}
                                      alt={itemi.subMenuImageTwo.title}
                                      height={594}
                                      width={362}
                                      loading="lazy"
                                      className="h-full w-full object-cover object-center"
                                    />
                                  )}
                                </div>
                              )
                            })}
                        </React.Fragment>
                      ))}
                  </div>

                  <div className="image_wrapper w-6/12 h-[calc(100%-135px)] absolute left-0 top-0 px-10">
                    {headerDataList?.sidebarMenu1.length > 0 &&
                      headerDataList.sidebarMenu1.map((itemimg, ig) => (
                        <React.Fragment key={ig}>
                          {Array.isArray(itemimg.innerMenuLinkTwo) &&
                            itemimg.innerMenuLinkTwo.length > 0 &&
                            itemimg.innerMenuLinkTwo.map((itemi, index) => {
                              const keyi = `submenu2-${ig}-${index}`
                              return (
                                <div
                                  key={keyi}
                                  onMouseEnter={() => handleMouseEnter(keyi)}
                                  className={
                                    keyi === hoveredItemId
                                      ? "show-image"
                                      : "hide-image"
                                  }
                                >
                                  {itemi.subMenuImageOne && (
                                    <img
                                      src={itemi.subMenuImageOne.mediaItemUrl}
                                      alt={itemi.subMenuImageOne.title}
                                      height={594}
                                      width={362}
                                      loading="lazy"
                                      className="h-full w-full object-cover object-center"
                                    />
                                  )}
                                </div>
                              )
                            })}
                        </React.Fragment>
                      ))}
                  </div>

                  <div className="image_wrapper w-6/12 h-[calc(100%-135px)] absolute right-0 top-0 px-10">
                    {headerDataList?.sidebarMenu1.length > 0 &&
                      headerDataList.sidebarMenu1.map((itemimg, ig) => (
                        <React.Fragment key={ig}>
                          {Array.isArray(itemimg.innerMenuLinkTwo) &&
                            itemimg.innerMenuLinkTwo.length > 0 &&
                            itemimg.innerMenuLinkTwo.map((itemi, index) => {
                              const keyi = `submenu2-${ig}-${index}`
                              return (
                                <div
                                  key={keyi}
                                  onMouseEnter={() => handleMouseEnter(keyi)}
                                  className={
                                    keyi === hoveredItemId
                                      ? "show-image"
                                      : "hide-image"
                                  }
                                >
                                  {itemi.subMenuImageTwo && (
                                    <img
                                      src={itemi.subMenuImageTwo.mediaItemUrl}
                                      alt={itemi.subMenuImageTwo.title}
                                      height={594}
                                      width={362}
                                      loading="lazy"
                                      className="h-full w-full object-cover object-center"
                                    />
                                  )}
                                </div>
                              )
                            })}
                        </React.Fragment>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`search-container relative ${searchIsOpen === null
            ? "hidden"
            : searchIsOpen === true
              ? "search-bx-open"
              : "search-bx-closed"
            }`}
        >
          <button
            type="button"
            className="absolute top-50 right-60"
            onClick={() => {
              handleSearchClose()
            }}
          >
            <img
              src="../../../images/close.svg"
              alt="close"
              height={11}
              width={11}
              loading="lazy"
            />
          </button>
          <div className="container-fluid text-center">
            <div className="title title-everglade">
              <h3>
                Find your next <span>adventure</span>
              </h3>
            </div>
            <div className="search-input-wrapper pt-30 mdscreen2:pt-20">
              <form
                onSubmit={event => {
                  event.preventDefault()
                  if (searchtext) {
                    setSearchMenu(false)
                    navigate(encodeURI("/search?q=" + searchtext), {
                      state: searchtext,
                    })
                  }
                }}
              >
                <div className="input-bx">
                  <input
                    type="text"
                    placeholder="Looking for something?"
                    value={searchtext || ""}
                    onChange={e => {
                      setSearchtext(e.target.value)
                    }}
                  />
                  <img
                    onClick={() => {
                      if (searchtext) {
                        setSearchMenu(false)
                        navigate(encodeURI("/search?q=" + searchtext), {
                          state: searchtext,
                        })
                      }
                    }}
                    src="/images/search.svg"
                    alt=""
                    className="search-icon-img h-20 w-20 absolute top-15 right-15 hover:cursor-pointer"
                  />
                </div>
                <button
                  className="relative z-99 top-[4px]"
                  id="mobileSearchIcon"
                  onClick={() => {
                    setSearchMenu(!searchMenu)
                  }}
                ></button>
              </form>
            </div>
            {headerDataList?.searchLink && (
              <div className="popular-searches pt-70 lgscreen:pt-50 mdscreen2:pt-40">
                <div className="pre-heading title-charcoal">
                  <span className="text-11 tracking-05em font-500">
                    Popular searches
                  </span>
                </div>
                <div className="search-suggestion pt-35 capitalize mdscreen2:pt-25">
                  <ul className="flex flex-wrap justify-center items-center gap-x-40 gap-y-25 mdscreen:gap-x-30 mdscreen:gap-y-20 max-w-[940px] mx-auto">
                    {headerDataList.searchLink.map((itemsearch, s) => (
                      <li key={s}>
                        <Link to={itemsearch.link.url}>
                          {itemsearch.link.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>

        {headerDataList.sidebarMenu1.map(
          (itemMenu, index) =>
            activeSubmenu === index && (
              <div
                key={index}
                className={`mobile-nav bg-white w-full fixed top-0 left-0 -translate-x-[110%]" -translate-x-[110%] max-w-[310px] h-full z-[99999] md:hidden transition-all duration-300 ease-in-out`}
                style={{
                  transform: mobileSubNavOpen
                    ? "translateX(0)"
                    : "translateX(-100%)",
                }}
              >
                <div className="relative">
                  <div className="mobile-navbar container-fluid absolute pt-30 z-[9999] w-full">
                    <button type="button" onClick={handleMobileSubMenu}>
                      <img
                        src="../../../images/close.svg"
                        width={15}
                        height={15}
                        alt="close-icon"
                        className="subnav-close-icon"
                        loading="eager"
                      />
                    </button>
                  </div>
                  <div className="mobile-menu px-40 pt-65">
                    <div className="menu-title flex items-center gap-15 px-10 opacity-30 pb-15 border-b-1 border-everglade border-opacity-10">
                      <button type="button" onClick={handleMobileSubMenu}>
                        <img
                          src="../../../images/arrow-lg.svg"
                          alt="back-arrow"
                          height={8}
                          width={18}
                          loading="lazy"
                          className="cursor-pointer"
                        />
                      </button>
                      <Link to={itemMenu.mainMenu.url}>
                        {itemMenu.mainMenu.title}
                      </Link>
                    </div>
                    {itemMenu?.innerMenuLinkOne && (
                      <div className="item_wrapper pt-35 first:pt-25">
                        {itemMenu?.preLinkOne && (
                          <div className="pre-heading title-charcoal">
                            <span>{itemMenu.preLinkOne.title}</span>
                          </div>
                        )}
                        <ul className="space-y-10">
                          {itemMenu?.innerMenuLinkOne.length > 0 &&
                            itemMenu.innerMenuLinkOne.map((itemS, l) => {
                              return (
                                <li key={l}>
                                  <Link
                                    to={itemS.subMenuLink.url}
                                    target={itemS.subMenuLink.target}
                                  >
                                    {itemS.subMenuLink.title}
                                  </Link>
                                </li>
                              )
                            })}
                        </ul>
                      </div>
                    )}
                    {itemMenu?.innerMenuLinkTwo && (
                      <div className="item_wrapper pt-35 first:pt-25">
                        {itemMenu?.preLinkTwo && (
                          <div className="pre-heading title-charcoal">
                            <span>{itemMenu.preLinkTwo.title}</span>
                          </div>
                        )}
                        <ul className="space-y-10">
                          {itemMenu?.innerMenuLinkTwo.length > 0 &&
                            itemMenu.innerMenuLinkTwo.map((itemS, m) => {
                              return (
                                <li key={m}>
                                  <Link
                                    to={itemS.subMenuLink.url}
                                    target={itemS.subMenuLink.target}
                                  >
                                    {itemS.subMenuLink.title}
                                  </Link>
                                </li>
                              )
                            })}
                        </ul>
                      </div>
                    )}
                    {itemMenu?.viewButton && (
                      <div className="btn-custom pt-50 mdscreen2:pt-35">
                        <Link
                          to={itemMenu.viewButton.url}
                          target={itemMenu.viewButton.target}
                          className="btn btn-border-everglade"
                        >
                          {itemMenu.viewButton.title}
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
        )}
      </section>
    </React.Fragment>
  )
}

export default Header
